import { render, staticRenderFns } from "./agreements_index_view.vue?vue&type=template&id=2e7f55c3"
import script from "./agreements_index_view.vue?vue&type=script&lang=js"
export * from "./agreements_index_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports